import './App.css';
import { Route, Switch } from "react-router-dom";
import LandingPage from "./pages/landingPage";
import AppSupportPage from './pages/supportPage';
import FaqPage from "./pages/faqPage";
import AppPreview from "./pages/appPreview";

const App = () => {
  return (
    <Switch>
      <Route
        exact
        path="/support"
        render={(props) => <AppSupportPage {...props} />}
      />
      <Route exact path="/faqs" render={(props) => <FaqPage {...props} />} />
      <Route
        exact
        path="/app-previews"
        render={(props) => <AppPreview {...props} />}
      />
      <LandingPage />
    </Switch>
  );
}

export default App;
